import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react';
import {
  SaveAndExitButton,
  CancelButton,
} from '@bingads-webui-react/wizard-ui-library';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { MessageBar, MessageBarTitle, MessageBarBody } from '@fluentui/react-message-bar';
import {
  Text,
  makeStyles,
  shorthands,
  tokens
} from '@fluentui/react-components';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';


const useStyles = makeStyles({
  warning: {
    ...shorthands.margin(tokens.spacingVerticalL, tokens.spacingVerticalNone),
  },
});

export const EditFooter = ({
  saveAndExitButtonText,
  cancelButtonText,
}) => {
  const i18n = useContext(I18nContext);
  const styles = useStyles();
  const { dynamic: { AWFWebExclusionsWarning: showAWFWarning } } = useContext(PermissionsContext);

  return (
    <>
      {showAWFWarning && (
        <Stack>
          <div className={styles.warning}>
            <MessageBar layout="multiline">
              <MessageBarBody>
                <MessageBarTitle>{i18n.getString(_TL_('Note'))}</MessageBarTitle>
                <Text size={200}>{i18n.getString(_TL_('Please note that Audience campaigns will always serve on Microsoft sites (e.g., Microsoft Bing, Microsoft Casual Games, MSN, and Outlook.com) even if you’ve added website exclusions for them.'))}</Text>
              </MessageBarBody>
            </MessageBar>
          </div>
        </Stack>
      )}
      <Stack horizontal tokens={{ childrenGap: 16 }}>
        <SaveAndExitButton buttonText={saveAndExitButtonText} />
        <CancelButton buttonText={cancelButtonText} />
      </Stack>
    </>
  );
};

EditFooter.propTypes = {
  saveAndExitButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
};

EditFooter.defaultProps = {
  saveAndExitButtonText: undefined,
  cancelButtonText: undefined,
};
